"use strict";

angular.module('app.modals.addFavorite', [])

    .controller('addFavoriteModalCtrl', ['$scope', '$state', 'favoriteObject', 'close', '__Favorite', 'f_User', '$q','selectIconModal','f_Favorites','ENUM',
        function ($scope, $state, favoriteObject, close, __Favorite, f_User, $q,selectIconModal,f_Favorites,ENUM) {
            var userLevel =f_User.getUserLevel();
            $scope.DeviceTypesAsKeys = ENUM.getDeviceTypesByFilter('1AsKey');
            var FavoriteDefaults =
            {
                ShowOnStartScreen:true,
                UserLevelRead : userLevel,
                UserLevelWrite : userLevel,
                ImageName : 'favorit',
                Position : 1,
                $UI :{
                    canWrite : true,
                    editMode : true
                }
            }
            //$scope.$emit('ModalOpen');
            $scope.favoriteObject = favoriteObject;
            $scope.newFavorite = __Favorite.$build();
            /*var UserLevel = f_User.getUserLevel();
             $scope.newFavorite.UserLevelRead = UserLevel;
             $scope.newFavorite.UserLevelWrite = UserLevel;
             $scope.newFavorite.ImageName = '';
             $scope.newFavorite.Position = -1;
             $scope.newFavorite.UITags = {};*/

            $scope.close = function () {
                close();
            };

            $scope.init = function () {
                // Todo: Move to factory function resolveBMSType we will need this in future in som other places
                //
                var t = {};
                t.UserLevelRead  = 0;
                t.UserLevelWrite  = 0;
                var o = angular.merge({},FavoriteDefaults),
                    _type;
                $scope.temp = {
                    ShowOnStartScreen : true,
                    FavoriteSceneType: 0
                }

                if (angular.isDefined(favoriteObject.DatapointConfig)
                ) {
                    // Restmod __Datapoint
                    t._type = 'BMS.Shared.Model.System.FavoriteDatapoint, BMS.Shared';
                    o.DatapointConfigId = favoriteObject.DatapointConfig.DatapointConfigId;
                    o.DisplayName = angular.copy(favoriteObject.DatapointConfig.DisplayName);
                    o.DeviceId = favoriteObject.DatapointValue.DeviceId;
                    if(favoriteObject.DatapointConfig.ImageName){
                        o.ImageName = favoriteObject.DatapointConfig.ImageName;
                    }

                } else if (angular.isDefined(favoriteObject.SceneId)) {
                    t._type = 'BMS.Shared.Model.System.FavoriteScene, BMS.Shared';
                    o.SceneId = favoriteObject.SceneId;
                    o.DisplayName = favoriteObject.DisplayName;
                    o.FavoriteSceneType = 0;
                    o.ImageName = 'szene';
                    o.editMode =true;
                    o.$UI.editMode = true;

                } else if (angular.isDefined(favoriteObject.MenuEntryType)) {
                    switch (favoriteObject.MenuEntryType) {
                        case 0:
                        case 1:
                        case 2:
                            t._type = 'BMS.Shared.Model.System.FavoriteMenuEntry, BMS.Shared';
                            break;
                        case 3:

                            t._type = 'BMS.Shared.Model.System.FavoriteCustomAction, BMS.Shared';
                            o.CustomActionName = favoriteObject.CustomActionName;
                            o.CustomActionData = favoriteObject.CustomActionData;
                           // o.UITags = favoriteObject.UITags;
                            break;
                    }
                    o.DeviceId = favoriteObject.DeviceId;
                    o.MenuEntryId = favoriteObject.MenuEntryId;
                    o.MenuEntryType = favoriteObject.MenuEntryType;
                    o.ImageName = favoriteObject.ImageName;
                    o.DisplayName = favoriteObject.DisplayName;
                    o.UITags = favoriteObject.UITags;
                } else if (angular.isDefined(favoriteObject.DeviceId)) {

                    t._type = 'BMS.Shared.Model.System.FavoriteDevice, BMS.Shared';
                    o.DeviceId = favoriteObject.DeviceId;
                    o.DeviceType = favoriteObject.DeviceType;
                    o.DisplayName = favoriteObject.Name;
                    o.ImageName = $scope.DeviceTypesAsKeys[favoriteObject.DeviceType].Image.Name;


                }else{
                    o = angular.extend(o,favoriteObject);
                }

                $scope.$UI = {editMode:true};
                t.$type = t._type;
                // To set Type first.
                var newFavorite =  angular.extend(t, o );
                $scope.Favorite = __Favorite.$buildRaw(newFavorite);

                /* TODO: The newFavorite is nearly obsolete, remove it
                completely from the system. */
                $scope.newFavorite = $scope.Favorite;
                $scope.newFavorite.$UI.editMode = true;
                $scope.newFavorite.$UI.hideDelete = true;

            }
            $scope.save = function () {
                // Switch of Object

                // Get Last Favorite Position
                $scope.$emit('loading-start');
                var f = __Favorite.$getAll().$then(function(data){
                    var max = 0;
                    var count = 0;
                    for(var i = 0; i < data.length; i++)
                    {
                        if(data[i].ShowOnStartScreen === $scope.newFavorite.ShowOnStartScreen)
                        {
                            if(data[i].Position >= max)
                            {
                                max = data[i].Position;
                                count++;
                            }
                        }
                    }
                    if(max >= 0 && count > 0)
                    {
                        max = max + 1;
                    }
                    $scope.newFavorite.Position = max;

                    // Inc Last Position


                    // And Save to Database.
                   $scope.newFavorite.$save().$then(function (data) {
                       // Get Favorite so we have the DatapointConfig & Value
                       var newFavoriteId = data.FavoriteId;
                       // var newFav = __Favorite.$byId(data.FavoriteId);
                       __Favorite.$getAll().$then(function(data){

                           var newFav = data.find(x => x.FavoriteId == newFavoriteId);
                           $scope.$emit('loading-stop');
                           close(newFav);
                       })
                       // close with new Favorite as resolve


                    },function(){

                   });

                    return data;
                })


            }


            $scope.changeFavoriteStartscreen = function(val, params)
            {
                if (val.value == true) {
                    $scope.newFavorite.ShowOnStartScreen = 1;
                } else {
                    $scope.newFavorite.ShowOnStartScreen = 0;
                }
            }

            $scope.changeStartScreen = function(){
                if(val.value === true)
                {
                    $scope.newFavorite.ShowOnStartScreen = true;
                }else{
                    $scope.newFavorite.ShowOnStartScreen = false;
                }
            }

            $scope.changeFavoriteType = function (val, params) {

                if (val.value === true) {
                    $scope.newFavorite.FavoriteSceneType = 1;
                } else {
                    $scope.newFavorite.FavoriteSceneType = 0;
                }
            };
            $scope.init();
        }
    ])

    .factory('addFavoriteModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (favoriteObject) {

            return ModalService.showModal({
                templateUrl: "views/modals/addFavorite.html",
                controller: 'addFavoriteModalCtrl',
                inputs: {
                    favoriteObject: favoriteObject
                }
            });


        }
    }]);